import { pnGenericFormReducer } from './Reducers/PNGenericForm.reducer';

export const pnGenericForm = {
    pnGenericFormReducer
};